import { useTasks } from "~/apis/use-tasks";
import { useFileSync } from "~/hooks/use-sync";
import { TabWindowsProvider } from "./tab-windows/context/tab-windows-provider";
import type { ExplorerItem } from "./task.types";
import { TasksPageContent } from "./tasks-page-content";

export const TasksPage = () => {
  useFileSync("Task");

  const { tasks } = useTasks();

  return (
    <TabWindowsProvider<ExplorerItem> tasks={tasks}>
      <TasksPageContent tasks={tasks} />
    </TabWindowsProvider>
  );
};
